import { Icon } from "@iconify/react";
import { cn } from "../../../../helper/utilityHelper";
import { Button } from "../../../../components/ui/button";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Common from "../../../../helper/common";

import { PrintReceipt } from "../../../../components/print";

import { FaRedo } from "react-icons/fa";
import dayjs from "dayjs";

import {
  BookingModeEnum,
  BookingPaymentMethodEnum,
  BookingStatusEnum,
  BookingTypeEnum,
  PaymentStatusEnum,
  PaymentTypeEnum,
  ViewDateTimeFormat,
  AppUserSettingsTypeEnum,
  respEnum
} from "../../../../constants/appConstant";
import DialogModal from "../../../../components/partials/modal/dialogModal";
import { Formik } from "formik";
import { FormikInput, FormikSearchSelect } from "../../../../components/formik-components";
import common from "../../../../helper/common";

const BookingDetailSidebar = ({
  booking,
  setBooking,
  setShowAddPayment,
  getBookingDetails,
  setShowReschedule,
  setShowAddDiscount,
  setShowCancelBooking,
  setShowNotes,
  setShowAddTax,
  isAddingPayment,
  isAddingDiscount,
  isRescheduling,
  isCancelling,
  isAddingNotes,
  isAddingTax,
  
}) => {
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);

  // Prepare booking data for printing
  const preparePrintData = () => {
    return {
      "Club Name": booking?.club?.name || "N/A",
      "Reference Number": booking?.refNo || "N/A",
      "Booking Mode": booking?.bookingMode
        ? Common.Utility.getKeyByValue(BookingModeEnum, booking.bookingMode)
        : "N/A",
      "Booking Date": booking?.bookingDate
        ? Common.moment(booking.bookingDate).format("dddd, DD MMM yyyy")
        : "N/A",
      Time: booking?.bookingDetail || "N/A",
      Court: booking?.courtName || "N/A",
      "Player Name": booking?.bookedBy || "N/A",
      "Player Cell": booking?.playerCellNo || "N/A",
      "Payment Mode": booking?.paymentTypeId
        ? Common.Utility.getKeyByValue(PaymentTypeEnum, booking.paymentTypeId)
        : "N/A",
      // "Status": booking?.bookingStatus
      //   ? Common.Utility.getKeyByValue(BookingStatusEnum, booking.bookingStatus)
      //   : "N/A",
      "Payment Status": booking?.paymentStatus
        ? Common.Utility.getKeyByValue(PaymentStatusEnum, booking.paymentStatus)
        : "N/A",
      "Court Charges": booking?.courtcharges
        ? `Rs. ${booking.courtcharges}`
        : "N/A",
      Discount: booking?.discountAmount
        ? `Rs. ${booking.discountAmount}`
        : "Rs. 0",
      // "Promo Code": booking?.promocode || "N/A",
      Total: booking?.total ? `Rs. ${booking.total}` : "N/A",
      "Received Amount": booking?.receivedAmount
        ? `Rs. ${booking.receivedAmount}`
        : "Rs. 0",
      "Remaining Amount": booking?.remainingAmount
        ? `Rs. ${booking.remainingAmount}`
        : "Rs. 0",
      // "Created By": booking?.createdByName || "N/A",
      // "Created On": booking?.createdOn
      //   ? Common.moment(booking.createdOn).add(5, 'hours').format(ViewDateTimeFormat)
      //   : "N/A",

      // "Cancel Reason": booking?.cancelReason || "N/A"
    };
  };

  const [showChangePlayer, setShowChangePlayer] = useState(false);
  const [playerList, setPlayerList] = useState([]);

  const [changePlayerData, setChangePlayerData] = useState({
    currentPlayerName: "",
    bookingId: null,
  });

  useEffect(() => {
    if (booking) {
      setChangePlayerData({
        currentPlayerName: booking?.bookedBy ?? "",
        bookingId: booking?.id ?? null,
      });
    }
  }, [booking]);


  const getCustomers = async () => {
    return new Promise(async (res) => {
      const response = await Common.ApiService.getInstance().request(
        "ClubPlayersddl",
        {},
        "Get",
        false
      );
      const customers = [...(response?.data ?? [])];
      setPlayerList(customers);
    });
  };

  const handleChangePlayerModal = (id) => {
    setChangePlayerData({
      currentPlayerName: booking?.bookedBy,
      bookingId: booking.id,
    });
    getCustomers();
    setShowChangePlayer(true);
  };
  const _renderChangeModal = ({ onClose }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const ChangePlayerSchema = Yup.object().shape({
      new_player: Yup.number().required("Please select a new player"),
    });

    return (

      <div className="modal-scroll-container">
        <Formik
          enableReinitialize
          initialValues={{
            currentPlayerName: changePlayerData.currentPlayerName || "",
            bookingId: changePlayerData.bookingId || null,
            new_player: "",
          }}

          validationSchema={ChangePlayerSchema}
          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={async (values, action) => {
            if (isSubmitting) return;

            setIsSubmitting(true);

            try {
              let data = {
                booking_id: values.bookingId,
                new_player_id: values.new_player,
              };

              debugger
              let response = await Common.ApiService.getInstance().request(
                "ChangeBookingPlayer",
                data,
                "POST"
              );

              setIsSubmitting(false);
              action.setSubmitting(false);

              if (response.status === respEnum.Success) {
                if (response.data && typeof response.data === 'object') {
                  setBooking(response.data);
                } else {
                  await getBookingDetails();
                }

                common.SweetAlert.alert(response.message, "success");
                setTimeout(() => {
                  onClose();
                }, 100);
              } else {
                common.SweetAlert.alert(response.message || "Failed to change player", "error");
              }
            }
            catch (error) {
              setIsSubmitting(false);
              action.setSubmitting(false);
              console.error("Error changing player:", error);
              common.SweetAlert.alert("An error occurred while changing player", "error");
            }
          }
          }
        >
          {(formikProps) => (
            <>
              <div className="flex flex-col gap-2 mt-3">
                <FormikInput
                  formikProps={formikProps}
                  name="currentPlayerName"
                  label="Current Player Name"
                  disabled={true}
                />
              </div>

              <div className="flex flex-col gap-2 mt-3">
                <FormikSearchSelect
                  formikProps={formikProps}
                  name="new_player"
                  label="Player List"
                  data={playerList || []}
                />
              </div>

              <div className="mt-5 text-right flex gap-2 justify-end">
                <Button
                  type="button"
                  variant="primary"
                  onClick={() => formikProps.handleSubmit()}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <Icon icon="eos-icons:loading" className="w-4 h-4 mr-2" />
                      Updating...
                    </>
                  ) : (
                    "Change"
                  )}
                </Button>

                <Button
                  type="button"
                  variant="outline"
                  onClick={() => onClose(null)}
                  disabled={isSubmitting}
                >
                  Close
                </Button>
              </div>
            </>
          )}
        </Formik>
      </div>
    );
  };
  const openModal = (imgSrc) => {
    setModalImage(imgSrc);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalImage(null);
  };

  const bookingInfo = [
    {
      icon: "heroicons:bookmark",
      label: "Booking Mode",
      value: booking?.bookingMode
        ? Common.Utility.getKeyByValue(BookingModeEnum, booking.bookingMode)
        : null,
    },
    {
      icon: "heroicons:calendar",
      label: "Booking Date",
      value: booking?.bookingDate
        ? Common.moment(booking.bookingDate).format("dddd, DD MMM yyyy")
        : null,
    },
    {
      icon: "heroicons:clock",
      label: "Time",
      value: booking?.bookingDetail,
    },
    // {
    //   icon: "heroicons:clock",
    //   label: "Id",
    //   value: booking?.id,
    // },
    {
      icon: "heroicons:map",
      label: "Sport",
      // value: booking?.sportName || "-",
      value: booking?.selectedsport || booking?.sportName || "-",
    },
    {
      icon: "heroicons:map",
      label: "Court",
      value: booking?.courtName,
    },


    //  (booking?.bookingStatus === BookingStatusEnum.Booked && booking?.paymentStatus === PaymentStatusEnum.Un_Paid)
    //   ? {
    //       icon: "heroicons:user",
    //       label: "Player Name",
    //       value: (
    //         <>
    //         <div className="relative inline-block">
    //           <FaRedo
    //             className="absolute -top-2 -right-2 text-blue-500 cursor-pointer bg-white rounded-full shadow-md hover:bg-blue-50 transition-colors receipt-reupload-icon"
    //             onClick={() => handleChangePlayerModal(booking.id)}
    //             />
    //             <span>{booking?.bookedBy}</span>
    //         </div>
    //         </>
    //       ),
    //     }
    //   : {
    //       icon: "heroicons:user",
    //       label: "Player Name",
    //       value: booking?.bookedBy,
    //     },

    ...(booking?.bookingStatus === BookingStatusEnum.Booked && booking?.paymentStatus === PaymentStatusEnum.Un_Paid && (!booking?.discountAmount || booking?.discountAmount <= 0) ?
      [
        {
          icon: "heroicons:user",
          label: "Player Name",
          value: (
            <>
              <div className="relative inline-block">
                {dayjs(booking?.startDateTime).isAfter(dayjs()) && (
                  <FaRedo
                    className="absolute -top-2 -right-2 text-blue-500 cursor-pointer bg-white rounded-full shadow-md hover:bg-blue-50 transition-colors receipt-reupload-icon"
                    onClick={() => handleChangePlayerModal(booking.id)}
                  />
                )}
                <span>{booking?.bookedBy}</span>
              </div>
            </>
          ),
        }
      ] :
      [
        {
          icon: "heroicons:user",
          label: "Player Name",
          value: booking?.bookedBy,
        },
      ]),


    {
      icon: "heroicons:phone",
      label: "Player Cell #",
      value: booking?.playerCellNo ?? "-",
    },

    // {
    //   icon: "heroicons:exclamation-circle",
    //   label: "Type",
    //   value: booking?.bookingStatus
    //     ? Common.Utility.getKeyByValue(BookingTypeEnum, booking.bookingType)
    //     : null,
    // },
    {
      icon: "heroicons:shield-check",
      label: "Payment Mode",
      value: booking?.paymentTypeId
        ? Common.Utility.getKeyByValue(PaymentTypeEnum, booking.paymentTypeId)
        : null,
      shouldRender:
        booking?.paymentTypeId !== null &&
        booking?.paymentTypeId == PaymentTypeEnum.Pay_On_Club,
    },
    {
      icon: "heroicons:clipboard-document-check",
      label: "Status",
      value: booking?.bookingStatus
        ? Common.Utility.getKeyByValue(BookingStatusEnum, booking.bookingStatus)
        : null,
    },
    {
      icon: "heroicons:credit-card",
      label: "Payment Status",
      value: booking?.bookingStatus
        ? Common.Utility.getKeyByValue(PaymentStatusEnum, booking.paymentStatus)
        : null,
    },
    // {
    //   icon: "heroicons:shield-check",
    //   label: "No of Player",
    //   value: booking?.noofplayers,
    // },
    // {
    //   icon: "heroicons:shield-check",
    //   label: "Level Range",
    //   value:
    //     booking?.bookingMode == BookingModeEnum.App_Booking
    //       ? `${booking?.fromLevel} - ${booking.tillLevel}`
    //       : "-",
    // },
    // {
    //   icon: "heroicons:shield-check",
    //   label: "Payment Method",
    //   value: booking?.paymentMethod
    //     ? Common.Utility.getKeyByValue(
    //         BookingPaymentMethodEnum,
    //         booking.paymentMethod
    //       )
    //     : null,
    // },
    {
      icon: "heroicons:wallet",
      label: "Court Charges",
      value: booking?.courtcharges,
    },

    {
  icon: "heroicons:bookmark",
  label: "Tax Amount (Inc)",
  value: booking?.taxlogs?.reduce(
    (sum, tax) => sum + (tax.amount || 0),
    0
  ),
  shouldRender:
    booking?.taxlogs &&
    booking.taxlogs.length > 0 &&
    booking.taxlogs.some(tax => (tax.amount || 0) > 0),
},

    // {
    //   icon: "heroicons:shield-check",
    //   label: "PlatForm Fee",
    //   value: booking?.platformfee ?? "0",
    // },
    {
      icon: "heroicons:tag",
      label: `Discount ${booking?.promocode ? `(Promocode: ${booking.promocode})` : ""
        }`,
      value: booking?.discountAmount,
    },
    // {
    //   icon: "heroicons:shield-check",
    //   label: "Promo Code",
    //   value: booking?.promocode,
    // },
    {
      icon: "heroicons:calculator",
      label: "Total",
      value: booking?.total,
    },
    {
      icon: "heroicons:banknotes",
      label: "Receive Amount",
      value: booking?.receivedAmount,
    },
    {
      icon: "heroicons:currency-rupee",
      label: "Remaining Amount",
      value: booking?.remainingAmount,
    },

    {
      icon: "heroicons:user",
      label: "Created By",
      value: booking?.createdByName,
      shouldRender: !!booking?.createdByName,
    },
    {
      icon: "heroicons:calendar-days",
      label: "Created On",
      value: booking?.createdOn
        ? Common.moment(booking.createdOn)
          .add(5, "hours")
          .format(ViewDateTimeFormat)
        : "-",
      shouldRender: !!booking?.createdOn,
    },

    // cancelled by and cancelledon showing when BookingStatus is Cancelled or Cancelled_By_Club
    {
      icon: "heroicons:user",
      label: "Cancelled By",
      value: booking?.cancelledByName,
      shouldRender: !!booking?.cancelledByName,
    },

    {
      icon: "heroicons:calendar-days",
      label: "Cancelled On",
      value: booking?.cancelledon
        ? Common.moment(booking.cancelledon)
          .add(5, "hours")
          .format(ViewDateTimeFormat)
        : "-",
      shouldRender: !!booking?.cancelledon,
    },

    ...(booking.bookingStatus === BookingStatusEnum.Cancelled_By_Club ||
      booking.bookingStatus ===
      BookingStatusEnum.Cancelled_Due_To_Lack_Of_Player ||
      booking.bookingStatus === BookingStatusEnum.Cancelled
      ? [
        {
          icon: "heroicons:question-mark-circle",
          label: "Cancel Reason",
          value: booking?.cancelReason || "-",
        },
      ]
      : []),

    {
      icon: "heroicons:document-check",
      label: "Payment Receipt",
      value: booking?.paymentReceipt || "-",
      shouldRender: !!booking?.paymentReceipt,
      type: "image",
    },
  ];

  return (
    <>
      <ul className=" ">
        {bookingInfo
          .filter((item) => item.shouldRender !== false)
          .map((item, index) => {
            const fullImagePath =
              item.type === "image"
                ? Common.Utility.getImagePath(item.value)
                : null;

            return (
              <>
                <li
                  key={`filter-key-${index}`}
                  className={cn(
                    "cursor-pointer  flex justify-between items-center gap-1.5 p-2 rounded group hover:bg-primary/10"
                  )}
                >
                  <span
                    className={cn(
                      "flex  items-center gap-1.5  rounded group text-sm font-medium text-default-600 group-hover:text-primary",
                      ""
                    )}
                  >
                    <Icon
                      icon={item.icon}
                      className={cn(
                        "w-4 h-4 text-default-600 group-hover:text-primary",
                        ""
                      )}
                    />
                    {item.label}:
                  </span>
                  <span
                    style={{
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      width: "170px",
                    }}
                    className={`text-sm font-medium text-default-600 group-hover:text-primary ${item.type === "image" ? "flex justify-end" : "text-end"
                      }`}
                  >
                    {item.type === "image" ? (
                      <img
                        src={fullImagePath}
                        alt={item.label}
                        className="w-16 h-16 object-cover border rounded cursor-pointer"
                        onClick={() => openModal(fullImagePath)}
                      />
                    ) : (
                      item.value
                    )}
                  </span>
                </li>
              </>
            );
          })}
      </ul>
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-4 rounded-lg shadow-lg relative w-[85%] md:w-[50%] lg:w-[95%] h-[80%] md:h-[70%] lg:h-[60%] overflow-y-auto overflow-x-auto">
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl"
              onClick={closeModal}
            >
              &times;
            </button>
            <h2 className="text-lg font-bold mb-3 text-center">
              Payment Receipt
            </h2>
            <div className="flex justify-center">
              <img
                src={modalImage}
                alt="Full Receipt"
                className="max-w-[100%] max-h-[600px] object-contain rounded"
              />
            </div>
          </div>
        </div>
      )}
      {/* <div className="border border-dashed mt-3 border-default-300"></div> */}
      <div className="mt-3 md:px-4 px-2">
        {/* <div className="text-xs font-medium text-default-800 uppercase">
          Action
        </div> */}

        {/* <ul className="mt-3">
          {priorityFilters.map((item, index) => (
            <li
              key={`priority-item-${index}`}
              className="flex justify-between gap-2 space-y-4 cursor-pointer"
            >
              <div className="flex items-center gap-2">
                <span
                  className={cn(
                    `w-2 h-2 rounded-full block bg-${item.color} ring-${item.color}`,
                    {}
                  )}
                ></span>
                <span className="text-sm font-medium text-default-600">
                  {item.label}
                </span>
              </div>
              <span className="text-sm font-medium text-default-600">
                {item.total}
              </span>
            </li>
          ))}a
        </ul> */}

        {/* // (booking?.bookingMode === BookingModeEnum.Club_Booking ||
        //   (booking?.bookingMode === BookingModeEnum.App_Booking &&
        //     booking?.paymentTypeId === PaymentTypeEnum.Pay_On_Club || booking?.paymentTypeId === PaymentTypeEnum.Online_Partial_Pay)) &&
        // booking?.bookingStatus === BookingStatusEnum.Booked   */}
        {/* 
<div className="mt-3 md:px-4 px-2 fixed bottom-0 ml-[260px] bottom-btns bg-white z-50 left-0 py-3 border-default-300">   */}
        <div className="mt-3 md:px-4 px-2 fixed- bottom-0 gap-1 bottom-btns bg-white z-50 left-0 py-3 border-default-300">
          <Button
            className="mr-3 m-1 bg-[#856404] text-white hover:bg-[#856404]"
            onClick={() => navigate(-1)}
          >
            Back
          </Button>

          {!booking?.isPaid &&
            booking?.bookingStatus == BookingStatusEnum.Booked &&
            booking?.bookingType == BookingTypeEnum.Private && (
              <Button
                color="success"
                className="mr-3 m-1"
                onClick={() => setShowAddPayment(true)}
                disabled={isAddingPayment}
              >
                {isAddingPayment ? (
                  <>
                    <Icon icon="eos-icons:loading" className="w-4 h-4 mr-2" />
                    Processing...
                  </>
                ) : (
                  "Add Payment"
                )}
              </Button>
            )}

          {booking?.bookingStatus === BookingStatusEnum.Booked &&
            booking?.bookingType == BookingTypeEnum.Private &&
            !booking?.isPaid &&
            Common.Utility.ShowOnValidateDateOperation(
              booking,
              "startDateTime",
              ">=",
              true,
              global.user.appUserSettings?.find(setting => setting.type === AppUserSettingsTypeEnum.Add_Discount)?.value || 168
            ) && (
              //             booking?.paymentStatus === PaymentStatusEnum.Un_Paid &&
              // moment().isBetween(
              // moment(booking?.bookingDate).subtract(2, "days").startOf("day"), // 2 days before booking date
              // moment(booking?.bookingDate).endOf("day"),                      // End of the booking date
              // undefined,
              // "[]"
              // )
              <Button
                color="warning"
                className="mr-3 m-1"
                onClick={() => setShowAddDiscount(true)}
                disabled={isAddingDiscount}
              >
                {isAddingDiscount ? (
                  <>
                    <Icon icon="eos-icons:loading" className="w-4 h-4 mr-2" />
                    Processing...
                  </>
                ) : (
                  "Add Discount"
                )}
              </Button>
            )}

          {/* {booking?.bookingStatus === BookingStatusEnum.Booked &&
            moment(booking?.startDateTime).isSameOrAfter(
              Common.Utility.GetCurrentDateTime()
            ) && ( */}


              {booking?.bookingStatus === BookingStatusEnum.Booked &&
            Common.Utility.ShowOnValidateDateOperation(
              booking,
              "startDateTime",
              ">=",
              true,
              global.user.appUserSettings?.find(setting => setting.type === 
                AppUserSettingsTypeEnum.Reschedule_Booking)?.value || 
                moment(booking?.startDateTime).isSameOrAfter(
              Common.Utility.GetCurrentDateTime() )
            ) 
            && (

              <Button
                color="info"
                className="mr-3 m-1"
                onClick={() => setShowReschedule(true)}
                disabled={isRescheduling}
              >
                {isRescheduling ? (
                  <>
                    <Icon icon="eos-icons:loading" className="w-4 h-4 mr-2" />
                    Processing...
                  </>
                ) : (
                  "Reschedule"
                )}
              </Button>
            )} 


          {booking?.bookingStatus === BookingStatusEnum.Booked &&
            Common.Utility.ShowOnValidateDateOperation(
              booking,
              "startDateTime",
              ">=",
              true,
              global.user.appUserSettings?.find(setting => setting.type === AppUserSettingsTypeEnum.Cancel_Booking)?.value || 48
            ) && (
              <Button
                className="mr-3 m-1"
                color="destructive"
                onClick={async () => {
                  const isConfirmed = await Common.SweetAlert.confirmation(
                    "Are you sure you want to cancel this booking? This can't be reversed!",
                    "Confirm Cancel"
                  );
                  if (isConfirmed) {
                    setShowCancelBooking(true);
                  }
                }}
                disabled={isCancelling}
              >
                {isCancelling ? (
                  <>
                    <Icon icon="eos-icons:loading" className="w-4 h-4 mr-2" />
                    Cancelling...
                  </>
                ) : (
                  "Cancel Booking"
                )}
              </Button>
            )}

          {booking?.notes == null && (
            <Button
              className="mr-3 bg-[#0a9396] hover:bg-[#0a9396] text-white"
              onClick={() => setShowNotes(true)}
              disabled={isAddingNotes}
            >
              {isAddingNotes ? (
                <>
                  <Icon icon="eos-icons:loading" className="w-4 h-4 mr-2" />
                  Saving...
                </>
              ) : (
                "Add Note"
              )}
            </Button>
          )}

          {booking?.bookingStatus === BookingStatusEnum.Booked &&
            //(booking?.paymentStatus === PaymentStatusEnum.Un_Paid ||
            //              booking?.paymentStatus === PaymentStatusEnum.Partial_Paid) &&
                      (
              <Button
                color="info"
                className="mr-3 m-1"
                onClick={() => setShowAddTax(true)}
                disabled={isAddingTax}
              >
                {isAddingTax ? (
                  <>
                    <Icon icon="eos-icons:loading" className="w-4 h-4 mr-2" />
                    Processing...
                  </>
                ) : (
                  <>
                    <Icon icon="heroicons:calculator" className="w-4 h-4 mr-2" />
                    Add Tax
                  </>
                )}
              </Button>
            )}

          {/* && booking?.bookingMode == BookingModeEnum.Club_Booking */}
          {/*{booking?.bookingStatus === BookingStatusEnum.Booked &&*/}
          {/*  new Date(booking.startDateTime) > new Date() && (*/}
          {/*    <Button*/}
          {/*      color="destructive"*/}
          {/*      onClick={async () => {*/}
          {/*        const isConfirmed = await Common.SweetAlert.confirmation(*/}
          {/*          "Are you sure you want to cancel this booking? This can't be reversed!",*/}
          {/*          "Confirm Cancel"*/}
          {/*        );*/}
          {/*        if (isConfirmed) {*/}
          {/*          cancelledBooking();*/}
          {/*        }*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      Cancel Booking*/}
          {/*    </Button>*/}
          {/*            )}*/}
        </div>
      </div>
      {showChangePlayer && (
        <DialogModal
          title={
            <div className="flex items-center gap-3">
              <div className="bg-blue-100 p-2 rounded-lg">
                <Icon
                  icon="heroicons:document-arrow-up"
                  className="w-5 h-5 text-blue-600"
                />
              </div>
              <div>
                <h3 className="font-semibold text-lg">Change Player</h3>

              </div>
            </div>
          }
          open={showChangePlayer}
          setOpen={setShowChangePlayer}
          Child={() =>
            _renderChangeModal({
              onClose: () => setShowChangePlayer(false),
            })
          }
          className="max-w-2xl"
        />
      )}
    </>
  );
};

export default BookingDetailSidebar;
